import { expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

export type MigratedMacroExtensionKey =
	| 'blog-posts'
	| 'content-report-table'
	| 'contributors'
	| 'detailssummary'
	| 'include'
	| 'pagetree'
	| 'pagetreesearch'
	| 'profile'
	| 'profile-picture'
	| 'recently-updated'
	| 'viewpdf'
	| 'widget'
	| 'contentbylabel'
	| 'popular-labels';

const getExperimentValue = (extensionKey: MigratedMacroExtensionKey): boolean => {
	switch (extensionKey) {
		case 'blog-posts':
		case 'content-report-table':
		case 'contentbylabel':
		case 'contributors':
		case 'pagetree':
		case 'pagetreesearch':
		case 'popular-labels':
		case 'recently-updated':
		case 'widget':
			return expValEquals('cc_rewrite_legacy_macros_phase_1', 'isEnabled', true);
		case 'include':
		case 'viewpdf':
		case 'profile':
		case 'profile-picture':
		case 'detailssummary':
			return expValEquals('cc_rewrite_legacy_macros_phase_2', 'isEnabled', true);
		default:
			return false;
	}
};

const isMigratedMacroExtensionKey = (key: string): key is MigratedMacroExtensionKey =>
	[
		'blog-posts',
		'content-report-table',
		'contributors',
		'detailssummary',
		'include',
		'pagetree',
		'pagetreesearch',
		'recently-updated',
		'widget',
		'contentbylabel',
		'popular-labels',
		'profile',
		'profile-picture',
		'viewpdf',
	].includes(key);

export const isMigratedMacroImplEnabled = (extensionKey: string): boolean => {
	const overrideList = StatsigConfigurations.getStringList(
		'cc_macro_override_to_legacy_renderer',
		[],
	);

	if (overrideList.includes(extensionKey)) {
		return false;
	}

	if (!isMigratedMacroExtensionKey(extensionKey)) {
		return false;
	}

	return getExperimentValue(extensionKey);
};
